import React, {FC} from "react"
import {WithRouter} from "react-router-dom"

import DealByUrlSlug from "@irati/deals/apollo/query/DealByUrlSlug"
import RequireDealStatusOn from "@irati-web/perks/src/components/RequireDealStatusOn"
import {DealType} from "@irati/types"

const merchOrVoucher =
  (Merch: FC<WithRouter>, Voucher: FC<WithRouter>): FC<WithRouter> =>
  (props) => {
    const urlSlug = props.match?.params?.urlSlug
    if (!urlSlug) {
      return null
    }
    return (
      <DealByUrlSlug variables={{urlSlug, isRewards: true}} Error={RequireDealStatusOn}>
        {(res) => {
          if (res?.data?.dealBySlug?.type === DealType.Merchandise) {
            return <Merch {...props} deal={res?.data?.dealBySlug} />
          }
          // Voucher return deal components - used for both Perks and Flexi Rewards redemption flow
          return <Voucher {...props} deal={res?.data?.dealBySlug} />
        }}
      </DealByUrlSlug>
    )
  }

export default merchOrVoucher
